export enum MemoSignatureTagChoices {
  E_SIGN_ENABLED = "E-sign enabled",
  E_SIGN_INITIATED = "E-sign initiated",
  SIGNED = "Signed",
  E_SIGN_TERMINATED = "E-sign terminated",
}
